import React from 'react';
import PropTypes from 'prop-types';

import { getAlternativeByCondition } from './QuestionTypes.base';
import { Title } from 'modules/Core/Common';
import { replaceKeyByWord } from '../QuestionTypes.utils';

import * as S from '../../AnswerSheet.styles';

const CompletionComprehension = ({ alternatives }) => {
  return (
    <S.Container>
      {alternatives?.map((alternative) => (
        <S.SectionContainer key={alternative?.alternative_id}>
          <Title
            size="default"
            fontWeight="normal"
            style={{ marginBottom: '3rem' }}
            dangerouslySetInnerHTML={{
              __html: replaceKeyByWord(alternative?.alternative_title, '___'),
            }}
          />
          {alternative?.sub_alternatives?.alternatives?.map(
            (subAlternative, index) => (
              <S.AlternativeContainer
                key={subAlternative.alternative_id}
                correct={subAlternative.right && subAlternative.chosen_by_user}
                wrongChosen={
                  !subAlternative.right && subAlternative.chosen_by_user
                }
                rightNotChosen={
                  subAlternative.right && !subAlternative.chosen_by_user
                }
              >
                {getAlternativeByCondition(subAlternative, index)}
                <S.AlternativeText
                  dangerouslySetInnerHTML={{
                    __html: subAlternative.alternative_description,
                  }}
                />
              </S.AlternativeContainer>
            )
          )}
        </S.SectionContainer>
      ))}
    </S.Container>
  );
};

CompletionComprehension.propTypes = {
  alternatives: PropTypes.array,
};

export default CompletionComprehension;
